import React from 'react';
import { YesNoDialogWithInline } from '../../../yes-no-dialog-with-inline/yes-no-dialog-with-inline';

type Props = {
  weight?: number;
  titleDialog: string;
  triggerDialog?: React.ReactNode;
  childrenDialog: React.ReactNode;
  handleClick: () => Promise<void>;
  warning?: string;
};

export const TableCellDialog: React.FC<Props> = ({
  titleDialog,
  triggerDialog,
  childrenDialog,
  handleClick,
  warning,
}) => {
  return (
    <YesNoDialogWithInline
      childrenDialog={childrenDialog}
      handleClick={handleClick}
      inlineMessage={warning}
      inlineVariant="warning"
      titleDialog={titleDialog}
      triggerDialog={triggerDialog}
    />
  );
};
